<template>
  <div class="e-chat__item" :key="id" :class="`e-chat__item--${type}`">
    <div class="e-chat__message">
      <div class="e-chat__text" v-html="message.text"></div>
      <div class="e-avatar size-24 e-chat__avatar">
        <img :src="subject.avatar">
      </div>
    </div>
    <div class="e-chat__time">{{ formattedDate }}</div>
  </div>
</template>

<script>
	export default {
		name: "e-chat-message",
    props: {
		  type: {
		    type: String,
        default: 'from'
      },
      subject: {
		    type: Object,
        required: true,
      },
      id: {
		    type: Number,
        required: true,
      },
      message: {
		    type: Object,
        required: true,
      }
    },
    computed: {
      formattedDate() {
        return this.$moment(this.message.date).fromNow();
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/chat/message.vue